import { render, staticRenderFns } from "./PlatCert.vue?vue&type=template&id=44d6d19e"
import script from "./PlatCert.vue?vue&type=script&lang=js"
export * from "./PlatCert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports